export const KANBAN_PERMISSION_NAMESPACE = 'Tenant'
export const KANBAN_PERMISSION_OBJECT = 'global'

export const KanbanRelation = {
  BOARD_ADMIN: 'kanban.board.admin',
  BOARD_LISTER: 'kanban.board.list',
  BOARD_READER: 'kanban.board.read',
  BOARD_WRITER: 'kanban.board.write',
  CARD_ADMIN: 'kanban.card.admin',
  CARD_LISTER: 'kanban.card.list',
  CARD_READER: 'kanban.card.read',
  CARD_WRITER: 'kanban.card.write'
} as const
export type KanbanRelation = (typeof KanbanRelation)[keyof typeof KanbanRelation]
